export { default as LocalStoragePlugin } from './localStoragePlugin.js'
export { default as copyFaviconPlugin } from './copyFaviconPlugin.js'
export { default as PiniaPlugin } from './piniaPlugin.js'
